export default "__VITE_ASSET__a45643ec__"